import React, { useState } from "react";
import "./Signin.css";
import { FcShop } from "react-icons/fc";
import { PiShoppingCartFill } from "react-icons/pi";
import signin from "../assests/first page.jpg";
import vendorgif from "../assests/shop.gif";
import usergif from "../assests/trolly login.gif";
import { useNavigate } from "react-router-dom";

function SigninPage() {
  const [vendor, setvendor] = useState(false);
  const [user, setuser] = useState(false);

  const navigate = useNavigate();

  const handlevendor = (type) => {
    if (type === "merchant") {
      setvendor(true);
      setTimeout(() => {
        navigate("/AmbrosysSign");
      }, 5000);
    } else {
      setuser(true);
      setTimeout(() => {
        navigate("/usersign");
      }, 1800);
    }
  };

  return (
    <div className="signin-wrapper">
      <img src={signin} alt="Signin" className="signidn-bg" />
      <div className="signin-container">
        <div className="merchant-card" onClick={() => handlevendor("user")}>
          <PiShoppingCartFill
            size={148}
            style={{
              color: "rgb(243, 148, 24)",
              filter: `
              drop-shadow(1px 1px 0 rgb(82, 95, 43))  /* light green */
              drop-shadow(2px 2px 0 rgb(60, 97, 23))  /* medium green */
              drop-shadow(3px 3px 0 rgb(175, 168, 76))  /* dark green */
              `,
            }}
          />
          <p>Client</p>
        </div>
        <div className="merchant-card" onClick={() => handlevendor("merchant")}>
          <FcShop size={148} />
          <p>Ambrosys</p>
        </div>
      </div>
      {user && (
        <div className="blur">
          <img src={usergif} alt="Vendor" />
        </div>
      )}
      {vendor && (
        <div className="blur">
          <img src={vendorgif} alt="Vendor" />
        </div>
      )}
    </div>
  );
}

export default SigninPage;
